import http from "../http";


const AircraftsService = {

    GetAircraftsService: async () => {
        const Aircrafts = await http.instance.get("/Aircrafts");
        return Aircrafts.data;
    },

    GetAircraftService: async (id) => {
        const Aircraft = await http.instance.get("/Aircrafts/Id",{params:{id:id}});
        return Aircraft.data;
    },

    UpdateAircraft: async (form)=>{
        const aircraft = await  http.instance.post("/Aircrafts/Edit",form);
        return  aircraft;
    },

    AddAircraft: async (form)=>{
        const aircraft = await  http.instance.post("/Aircrafts/Add",form);
        return  aircraft;
    },

    DelAircraft: async (form)=>{
        // burada aircraft id yada form alır...
        const aircraft = await http.instance.post("/Aircrafts/Delete",form)
        return aircraft;
    }

};

export default AircraftsService;
